import { adminMutate } from '../../admin/primitives.js'
import { requestStepUp } from '../../shell/stepup-bus.js'

/**
 * ÉCRIRE DANS SONDE PAR LE RELAIS DE GESTION (21/10/2026).
 *
 * `METHOD /api/v1/supervision/v/<chemin de Sonde sans /v1/>` : le relais
 * exige le droit, le step-up et le mode sûr selon sa table fermée. Le
 * navigateur envoie `If-Match` (la version lue) et une `Idempotency-Key`
 * neuve ; `adminMutate` rejoue après step-up avec les MÊMES en-têtes.
 *
 * Sonde répond 428 STEPUP_REQUIRED pour un réglage sensible : si le relais le
 * laisse passer tel quel, on propose aussi la confirmation d'identité ici,
 * puis on rejoue à l'identique.
 */

export type ReponseEcriture = { error?: string; message?: string; details?: unknown; [k: string]: unknown }

function cleIdempotence(): string {
  const c = globalThis.crypto
  if (c && typeof c.randomUUID === 'function') return c.randomUUID()
  const o = new Uint8Array(16)
  c?.getRandomValues?.(o)
  return [...o].map((x) => x.toString(16).padStart(2, '0')).join('')
}

export async function ecrireSonde(
  method: 'POST' | 'PUT' | 'PATCH' | 'DELETE', chemin: string, corps?: unknown, ifMatch?: string | null,
): Promise<{ status: number; data: ReponseEcriture }> {
  const headers: Record<string, string> = { 'Idempotency-Key': cleIdempotence() }
  if (ifMatch) headers['If-Match'] = ifMatch
  const url = `/api/v1/supervision/v/${chemin.replace(/^\/+/, '')}`
  let r = await adminMutate<ReponseEcriture>(method, url, corps, { headers })
  if (r.status === 428 && r.data?.error === 'STEPUP_REQUIRED') {
    if (await requestStepUp()) r = await adminMutate<ReponseEcriture>(method, url, corps, { headers })
    else r = { status: 403, data: { error: 'STEPUP_REQUIRED' } }
  }
  return r
}
